import React from 'react'
import {Icon} from 'semantic-ui-react'

const chipStyle = (ordered) => {
  return {
    backgroundColor: ordered ? 'rgb(241,239,232)' : 'rgb(250,238,218)',
    color:           ordered ? 'rgb(95,94,90)'   : 'rgb(133,79,11)',
    padding: '3px 9px',
    borderRadius: '17px',
    fontSize: '12px',
    whiteSpace: 'nowrap',
    display: 'inline-block',
    marginLeft: '10px',
    verticalAlign: 'middle',
    cursor: 'default'
  }
}

// forwardRef + rest props so Popup can attach its ref and hover handlers to the
// span — it injects them by cloning the trigger, and a plain function component
// would silently drop them
const TicketChip = React.forwardRef(({ticketed, ticketsOrdered, ...rest}, ref) => {
  return (
    <span ref={ref} {...rest} style={chipStyle(ticketsOrdered)}>
      <Icon name='ticket' style={{fontSize: '13px', marginRight: '2px'}}/>Ticketed
    </span>
  )
})

export {TicketChip, chipStyle}
